

















import { Component, Vue, Prop } from "vue-property-decorator";
import { Modal, Button } from "ant-design-vue";

@Component({
  name: "CModal",
  components: {
    AModal: Modal,
    AButton: Button
  }
})
export default class CModal extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: "信息" }) title!: string;
  @Prop({ default: "保存" }) okText!: string;

  private created() {
    // undo
  }

  private close() {
    this.$emit("close");
    this.$emit("update:visible", false);
  }

  private ok() {
    this.$emit("ok");
  }
}
